export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  author: string;
  date: string;
  readTime: string;
  category: string;
  slug: string;
}

export const blogPosts: BlogPost[] = [
  {
    id: "1",
    title: "What is Ecosystem-Led Growth? A VC's Perspective",
    excerpt: "Ecosystem-led growth isn't just a buzzword—it's a fundamental shift in how B2B SaaS companies scale. Here's why hyperscaler partnerships are the new competitive advantage.",
    author: "Arun Mohan",
    date: "2025-01-15",
    readTime: "8 min read",
    category: "Strategy",
    slug: "ecosystem-led-growth"
  },
  {
    id: "2",
    title: "How to Reduce CAC by 80% Through Hyperscaler Partnerships",
    excerpt: "Data from our portfolio shows consistent 80% CAC reduction when companies align with hyperscaler ecosystems. Here's the playbook we use.",
    author: "Arun Mohan",
    date: "2025-01-10",
    readTime: "10 min read",
    category: "GTM Strategy",
    slug: "reduce-cac"
  },
  {
    id: "3",
    title: "The X-Factor Model: Why Capital Alone Isn't Enough",
    excerpt: "Traditional VC provides capital. We provide the X-Factor: Capital + Channels + Collaboration. Learn why this combination drives sustainable growth.",
    author: "Arun Mohan",
    date: "2025-01-05",
    readTime: "7 min read",
    category: "Investment Philosophy",
    slug: "xfactor-model"
  },
  {
    id: "4",
    title: "Building on AWS/Azure: Strategic Advantages for Startups",
    excerpt: "Choosing the right hyperscaler partnership can make or break your GTM strategy. Here's how to leverage AWS, Azure, and GCP for maximum impact.",
    author: "Arun Mohan",
    date: "2024-12-20",
    readTime: "9 min read",
    category: "Cloud Strategy",
    slug: "hyperscaler-advantages"
  },
  {
    id: "5",
    title: "From Seed to Scale: The Ecosystem-First Approach",
    excerpt: "Most startups think about ecosystem partnerships too late. We believe it should be part of your strategy from day one. Here's why and how.",
    author: "Arun Mohan",
    date: "2024-12-15",
    readTime: "6 min read",
    category: "Startup Growth",
    slug: "seed-to-scale"
  }
];
